export default __webpack_public_path__ + "static/media/app-bg-01.f20fea8f.png";